import type { Puzzle, PuzzleDifficulty } from "../types.ts";
import { generatePuzzle, DIFFICULTY_TIERS } from "../engine/puzzle-gen.ts";
import { dateToSeed } from "../engine/prng.ts";

// Launch epoch: Feb 6, 2026
const EPOCH = new Date("2026-02-06").getTime();

export function getTodaysPuzzleId(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}

export function getPuzzleNumber(): number {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return Math.floor((today - EPOCH) / (1000 * 60 * 60 * 24)) + 1;
}

export function getDailyDifficulty(difficultyName?: string): PuzzleDifficulty {
  return DIFFICULTY_TIERS[difficultyName ?? "medium"] ?? DIFFICULTY_TIERS.medium!;
}

export function getDailyPuzzle(difficultyName?: string): Puzzle {
  const id = getTodaysPuzzleId();
  const seed = dateToSeed(id);
  const difficulty = getDailyDifficulty(difficultyName);
  const puzzle = generatePuzzle(seed, difficulty);
  puzzle.id = id;
  return puzzle;
}

const HUB_URL = "http://localhost:3000";

export async function fetchDailyPuzzle(difficultyName?: string): Promise<Puzzle> {
  const id = getTodaysPuzzleId();
  const diff = difficultyName ?? "medium";
  try {
    const res = await fetch(`${HUB_URL}/api/puzzles/foldaway?date=${id}&difficulty=${diff}`);
    if (res.ok) {
      const { puzzle_data } = await res.json();
      return { ...puzzle_data, id };
    }
  } catch {}
  return getDailyPuzzle(difficultyName);
}
